// Global styling configurations for the BHA application
import { createGlobalStyle } from 'styled-components';
import { COLORS } from '../constants/colors';

// Export theme variables for use in theme.js
export const $colorPrimary = COLORS.$colorPrimary;
export const $colorSecondary = COLORS.$colorSecondary;
export const $fontFamily = '"Open Sans", -apple-system, BlinkMacSystemFont, sans-serif';

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: ${$fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: ${COLORS.textDark};
    background-color: ${COLORS.background};
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    color: ${COLORS.textDark};
  }

  a {
    color: ${COLORS.$mainBlue};
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: ${COLORS.heartRed};
    }
  }

  button {
    cursor: pointer;
  }
`;

export default GlobalStyles;